import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'firstBold'
})
export class FirstBoldPipe implements PipeTransform {
	transform(value: string): string {
		let arrStr = value.split(' ');
		let firstWord = arrStr[0];
		let restWords = arrStr.slice(1).join(' ');
		return `<h2 class='title-text'>
				${firstWord} <span>${restWords}</span>
			</h2>`;
	}
}
